const STORAGE_BASE_URL = 'https://www.c4workx.com/media/case-studies';

export const getStaticMediaPathCreator = (caseStudy: string) => {
  return (mediaName: string) => `${STORAGE_BASE_URL}/${caseStudy}/${mediaName}`;
};
